import React, { useState, useEffect } from 'react';
import { commonSelector } from '../Common/redux/selectors';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import Footer from '../CommonResp/Footer/Footer';
import Heading from '../CommonResp/Heading/Heading';
import Breadcrumbs from '../CommonResp/BreadcrumbsWithoutSchema/Breadcrumbs';
import { redirectToFunnel } from '../Common/utils/redirectToFunnel';
import MobileHeader from '../CommonResp/MobileHeader/MobileHeader';
import { directoryDataSelector } from './redux/selectors'
import WhiteCard from '../CommonResp/WhiteCard/WhiteCard';
import { getBreadCrumbObj } from '../CommonResp/utils';
import SeoContainerHeader from "../Common/SeoContainerHeader";
import AdBanner from '../../components/AdBanner/AdBanner';
import PageNotFound from '../CommonResp/PageNotFoud/PageNotFound';
import { CITY_DIRECTORY_PAGE, CITY_DIRECTORY_URL, OPERATOR_DIRECTORY_URL, ROUTES_DIRECTORY_PAGE, ROUTES_DIRECTORY_URL } from './redux/constants';


const OperatorPage = (props) => {
  const directoryStoreData = useSelector(directoryDataSelector);
  const [showClientContent, enableClient] = useState(false);
  const commonData = useSelector(commonSelector);

  useEffect(() => {
    enableClient(true);
  }, []);

  const adTechId = (() => {
    return "QlVTI09QRVJBVE9SIFNFTyNWSUVXIE1PUkUgQlVTRVM=";
  })();

  const moveToFunnel = () => {
    redirectToFunnel({});
  }

  const { directory = {}, footer_links, seo_meta = {}, canonical_url, notToCrawl = false, notToIndex=false } = directoryStoreData;
  const { pageNumber, pageType } = commonData;
  const currentNumber: number = (() => {
    try {
      return parseInt(pageNumber);
    } catch (err) {
      console.error(err);
    }
    return 1;
  })();

  const { title, total_pages, links = [], total_links } = directory;

  const previousPageNo = currentNumber > 0 ? currentNumber - 1 : "";
  const nextPageNo = currentNumber < total_pages ? currentNumber + 1 : "";
  const paginationNumbers = [...Array(total_pages)].map((_, i) => i + 1);

  const baseUrl: string = (() => {
    let subDirectory = ""
    if (pageType == CITY_DIRECTORY_PAGE) {
      subDirectory = CITY_DIRECTORY_URL
    } else if (pageType == ROUTES_DIRECTORY_PAGE) {
      subDirectory = ROUTES_DIRECTORY_URL
    } else {
      // if(pageType == OPERATOR_DIRECTORY_PAGE){
      subDirectory = OPERATOR_DIRECTORY_URL
    }
    // return `${__ENV_CONFIG__.__GOIBIBO__}${subDirectory}`
    return `https://www.goibibo.com${subDirectory}`
  })();

  const getUrl = (pageNo) => {
    return `${baseUrl}?pg=${pageNo}`;
  }

  const { h1_title = "", meta_title = "", meta_description = "", meta_keywords = "", breadcrumb = "" } = seo_meta;

  const { dirView, isDirDataPresent } = getView(links);
  const breadCrumbObj = getBreadCrumbObj(breadcrumb ?? "", canonical_url);

  return (
    <>
      <Helmet
        title={meta_title}
        meta={
          [{ name: 'description', content: meta_description },
          { name: 'keywords', content: meta_keywords },
          { property: 'og:title', content: meta_title },
          { property: 'og:description', content: meta_description },
          { property: 'og:image', content: 'https://gos3.ibcdn.com/bus-default-1489655303.jpg' },
          { property: 'og:url', content: canonical_url },
          notToCrawl ? { name: 'robots', content: 'noindex,nofollow' } : '',
          notToIndex ? { name: 'robots', content: 'noindex' } : '',
          ]
        }
        link={[
          {
            href: canonical_url,
            rel: 'canonical',
          },
        ]}
      />
      {notToCrawl ?
        <PageNotFound
          onUpdateSearch={moveToFunnel}
          showHeaderOnly={notToCrawl}
          footer_links={footer_links}
        />
        :
        <>
          <Helmet>
            <script type="application/ld+json">{`${JSON.stringify(breadCrumbObj)}`}</script>
          </Helmet>

          <div className="seoContainer">
            <div className="desktopOnly">
              <SeoContainerHeader onUpdateSearch={moveToFunnel} />
            </div>

            {showClientContent ? <MobileHeader title="Bus Tickets" moveToFunnel={moveToFunnel} /> : <></>}

            <div className="ContentWrapper">
              <div className="contentSection operatorsContentScetion">
                <div className="RgtSection">
                  <Heading content={h1_title}></Heading>
                  <Breadcrumbs content={breadcrumb}></Breadcrumbs>
                </div>
                <div className="LftSection">
                </div>
              </div>

              {showClientContent ? <AdBanner cid={adTechId} /> : <></>}

              <WhiteCard childClassName="heightAuto" content={dirView} heading={title} isContent={isDirDataPresent}></WhiteCard>

              <div className="paginationSection">
                {previousPageNo ? <a className="pageNumber" id="page-prev" href={getUrl(previousPageNo)} rel="prev">&lt;&lt; Previous </a> : <></>}
                {paginationNumbers.map((k, v) => {
                  return (
                    <a className={currentNumber == k ? "pageNumber pageActive" : "pageNumber"} key={k} id={`page-${k}`} href={getUrl(k)} rel={`page${k}`}>{k}</a>
                  )
                })}
                {nextPageNo ? <a className="pageNumber" id="page-next" href={getUrl(nextPageNo)} rel="next" > Next &gt;&gt; </a> : <></>}
              </div>
            </div>

            <Footer data={footer_links}></Footer>
          </div>
        </>}
    </>
  )
}

export default OperatorPage;

export const getView = (data) => {
  let view = []
  let liView = [];
  for (let index in data) {
    const { title, url } = data[index];
    liView.push(
      <li key={title + index}>
        {url ? <a href={url} title={title}>{title}</a> : <span title={title}>{title}</span>}
      </li>
    )
  }
  if (liView && liView.length) {
    view.push(<ul key={"dirView"}>{liView}</ul>)
  }
  return { dirView: view, isDirDataPresent: view.length ? true : false };
}
